<style lang="scss">
  @import '../resources/scss/metric.scss';
</style>

<script lang="ts">
  export let value: string
  export let unit = ''
  export let description: string
  export let detailisLastTwoElements = false

  export let valueClass = ''
  export let descriptionClass = ''
</script>

<div class="metric">
  <div
    class="d-flex align-items-baseline {detailisLastTwoElements
      ? 'last-detail-item'
      : ''}"
  >
    <h2 class="{valueClass} me-1">{value}</h2>
    <h4 class={valueClass}>{unit}</h4>
  </div>
  <div class="description">
    <h5 class={descriptionClass}>
      {description}
    </h5>
  </div>
</div>
